import { getHighlightBlockDataFromHtml } from './getHighlightBlockDataFromHtml';
import { cleanHighlightBlockHtml } from './cleanHighlightBlockHtml';
import { THighlightBodyBlock } from '../../types';
import { TArticleBody } from '../../../ArticleBodyRenderer/types';
import { getBodyBlockWithId } from '../../../ArticleBodyRenderer/services/getBodyBlockWithId';

export const getHighlightBlockFromHtml = (
  body: TArticleBody,
  blockId: string,
  html: string,
): THighlightBodyBlock | undefined => {
  const bodyBlock = getBodyBlockWithId(body, blockId);
  if (!bodyBlock) {
    return undefined;
  }

  const cleanedHtml = cleanHighlightBlockHtml(html);

  return {
    id: blockId,
    type: bodyBlock.type,
    data: getHighlightBlockDataFromHtml(bodyBlock.type, cleanedHtml),
  };
};
